import {
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  UPDATE_USER_SUCCESS,
  CREATE_USER_REQUEST,
  USER_REQUEST_FAILURE
} from './constants';

let initialState = {
  message: '',
  messageType: '',
  userId: '',
  userList: {},
  userDetail: {},
  masterData: {},
  currentlySending: false,
  metaDataLoaded: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case USER_LIST_REQUEST:
      return { ...state, currentlySending: action.loading };
    case USER_LIST_SUCCESS:
      return {
        ...state,
        userList: action.userList,
        masterData: action.masterData,
        currentlySending: false,
        message: '',
        messageType: '',
        metaDataLoaded: true
      };
    case GET_USER_REQUEST:
      return { ...state, userDetail: {}, currentlySending: true };
    case CREATE_USER_REQUEST:
      return { ...state, currentlySending: true };
    case GET_USER_SUCCESS:
      return {
        ...state,
        userId: action.userId,
        userDetail: action.userDetail,
        currentlySending: false
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        userId: action.userId,
        message: action.message,
        messageType: 'success',
        currentlySending: false
      };
    case USER_REQUEST_FAILURE:
      return { ...state, message: Array.isArray(action.error)? action.error.map(m => `${m}<br/>`).join('') : action.error, messageType: 'error', currentlySending: false };
    default:
      return state;
  }
}

export default reducer;
